
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-04-27-r3f-7-paring-ui",
      function () {
        return require("private-next-pages/blogs/2025-04-27-r3f-7-paring-ui/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-04-27-r3f-7-paring-ui"])
      });
    }
  